// extracted by mini-css-extract-plugin
module.exports = {"box":"UserMenu_box__31N1F","menuSection":"UserMenu_menuSection__1kVEh","menuTitle":"UserMenu_menuTitle__2b3ZZ","menuItem":"UserMenu_menuItem__3vvaM"};